/* Reopen Shopify's native consent manager; never store a second consent state. */
if (!customElements.get('bw-cookie-settings')) {
  customElements.define('bw-cookie-settings', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', async () => {
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        button.disabled = true;
        status.textContent = '';
        try {
          if (!window.privacyBanner?.showPreferences) {
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
              script.onload = resolve;
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }
          await window.privacyBanner.showPreferences();
        } catch (error) {
          status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu und versuche es erneut.';
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}
